import React from 'react';
import { Link,NavLink } from 'react-router-dom';

const Navbar = () => (
  <nav className="navbar navbar-expand-lg navbar-dark sticky-top">
    <div className="container">
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav">
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/">Home</NavLink></li>
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/contact-classes">Contact/Classes</NavLink></li>
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/books">Books/Chapters</NavLink></li>
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/research">Research</NavLink></li>
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/patent">Patent</NavLink></li>
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/infosys">Info Sys for Mngrs</NavLink></li>
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/websys">Web Sys&E-Comm</NavLink></li>
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/c++oops">C++&OOP</NavLink></li>
          {/* <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/contact">Contact</NavLink></li> */}
          <li className="nav-item"><NavLink activeclassname="active" className="nav-link" to="/blog">Blog</NavLink></li>
        </ul>
      </div>
    </div>
  </nav>
);

export default Navbar;
